import Popup from './frontend/popup';
import { getProductHtml } from './frontend/helper';
import './css/frontend.scss';



const popupButtons = document.querySelectorAll('.wpvqv-quick-view-btn');

popupButtons.forEach((button) => {

    button.addEventListener('click', (e) => {
        e.preventDefault();

        let product_id = button.getAttribute('data-product_id');

        let popupContent = document.querySelector('.popup-content');

        // get table
        getProductHtml(product_id).then((html) => {

            Popup.createPopup(html, {
                width: '60%',
                height: '55vh',
                onClose: function() {

                },
                onOpen: function() {
                    jQuery('.woocommerce-product-gallery').wc_product_gallery( wc_single_product_params );

                    jQuery('.variations_form').each(function() {
                        jQuery(this).wc_variation_form();
                        var $variation_form = jQuery(this);
                        $variation_form.on('found_variation', function(event, variation) {
                            // Update the main product image based on the selected variation
                            if (variation && variation.image.src) {
                                updateMainProductImage(variation.image);
                            }
                        });
                        $variation_form.on('reset_data', function() {
                            // Get the first variation image
                            var first_variation = $variation_form.data('product_variations')[1];
                            if (first_variation && first_variation.image.src) {
                                updateMainProductImage(first_variation.image);
                            }
                        });
                    });
                    // Initialize WooCommerce quantity script
                    jQuery('.cart').each(function() {
                        jQuery(this).wc_variation_form();
                    });
                }
            });

        });
    });
});
// Create a popup
function updateMainProductImage(image) {
    let wooProductGallery = document.querySelector('.woocommerce-product-gallery');
    if(wooProductGallery){
        let thumbs = wooProductGallery.querySelector('.flex-control-thumbs');
        let thumbsImage = thumbs.querySelector( 'li img[src="' + image.gallery_thumbnail_src + '"]');
        if(thumbsImage == null){
            image_reset(image);
        }else{
            jQuery(thumbsImage).trigger('click');
        }
    }
}

function image_reset(image){
    let productGallery = document.querySelector('.woocommerce-product-gallery');
    let gallery_nav = productGallery.querySelector('.flex-control-nav');
    let gallery_img = gallery_nav.querySelector('li:first-child img');
    
    product_img_wrap = productGallery.querySelector('.woocommerce-product-gallery__image, .woocommerce-product-gallery__image--placeholder');        
    product_img = product_img_wrap.querySelector('.wp-post-image');
    
    product_link = product_img_wrap.querySelector('a');
    
    product_zoom_image = product_img_wrap.querySelector('.zoomImg');
    if(product_zoom_image){
        product_zoom_image.setAttribute('src',image.src);
    }
    
    product_img.setAttribute('src',image.src);
    product_img.setAttribute('height',image.src_h);
    product_img.setAttribute('width',image.src_w);
    product_img.setAttribute('srcset',image.srcset);
    product_img.setAttribute('sizes',image.sizes);
    product_img.setAttribute('title',image.title);
    product_img.setAttribute('data-caption',image.caption);
    product_img.setAttribute('alt',image.alt);
    product_img.setAttribute('data-src',image.full_src);

    product_img.setAttribute('data-large_image',image.full_src);
    product_img.setAttribute('data-large_image_width',image.full_src_w);
    product_img.setAttribute('data-large_image_height',image.full_src_h);

    $(product_img_wrap).wc_set_variation_attr( 'data-thumb', image.src );

    gallery_img.setAttribute( 'src',image.gallery_thumbnail_src );
    product_link.setAttribute( 'href',image.full_src );
    
    $(gallery_img).trigger('click');
}